const scrollToTop = () => {
  if (typeof window !== 'undefined') {
    setTimeout(() => window.scrollTo(0, 0), 100);
  }
}

export default scrollToTop;
